module.exports = __webpack_public_path__ + "static/resume-1834b3ad24fb2dc48eee469497e0e9c9.pdf";